import { axios } from '@/services/axios';

export const createCarrier = (carrierData) => {
    return axios.post('/carrier/', carrierData);
};
